import { toString } from 'lodash';

import { stringHash } from 'utils/Hash';

const DIGITAL_GIFT_CARD_ID_IDENTIFIER = '_dgc_';

class StorefrontUtil {
  static generateDigitalGiftCardId = ({ id, email }) => {
    const emailHash = stringHash(email);

    return `${id}${DIGITAL_GIFT_CARD_ID_IDENTIFIER}${emailHash}`;
  };

  static getIdFromDigitalGiftCardId = dgcId => {
    const dgcIdStr = toString(dgcId);

    return dgcIdStr?.split(DIGITAL_GIFT_CARD_ID_IDENTIFIER)[0];
  };

  static isDigitalGiftCardId = id => {
    const idStr = toString(id);

    return idStr?.includes(DIGITAL_GIFT_CARD_ID_IDENTIFIER);
  };
}

export default StorefrontUtil;
